var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.loading)?_c('el-tag',{attrs:{"size":"small","type":"info"}},[_vm._v("\n    "+_vm._s('-')+"\n  ")]):(_vm.colorValue)?_c('el-tag',{attrs:{"type":_vm.colorValue,"size":"small"}},[_vm._v("\n    "+_vm._s(_vm.labelText)+"\n  ")]):_c('span',[_vm._v(_vm._s(_vm.labelText))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6240ed05","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DictTag.vue
// module id = null
// module chunks = 